export function positionReplace(string: string, start: number, length: number, replacement: string) {
    return string.slice(0, start) + replacement + string.slice(start + length);
}

export function capitalize(s: string) {
    if (!s || s.length < 1) {
        return '';
    }

    return s.charAt(0).toUpperCase() + s.substring(1);
}

export function validateEmail(value: string): boolean {
    return /^[^\s]+@[^\s]+$/.test(value);
}

export function validatePhone(value: string): boolean {
    return window.intlTelInputUtils.isValidNumber(value);
}

export function getNumberValue(value: string) {
    const regex = /[^0-9,.]/g;
    const sanitizedValue = String(value).replace(regex, '');

    return (value === null || value === undefined || value === '')
        ? ''
        : +String(sanitizedValue).replace(',', '.');
}

// Keep only digits, comma, and dot so a decimal point survives while typing
export function filterNumericInput(value: string): string {
    return value.replace(/[^0-9,.]/g, '');
}